export function pluralPharmaciesAmount(counter: number) {
  let txt;
  let count = counter % 100;

  if (count >= 5 && count <= 20) {
    txt = "аптеках";
  } else {
    count = count % 10;
    if (count == 1) {
      txt = "аптеке";
    } else if (count >= 2 && count <= 4) {
      txt = "аптеках";
    } else {
      txt = "аптеке";
    }
  }
  return txt;
}
